import request from '@/plugins/request'

export function getKeytypeList(key, cateIds, pageindex, pagesize) {
    return request({
        url: '/v1/KeyType/GetKeyTypeList',
        method: 'post',
        data: {
            key: key,
            cateIds: cateIds,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}


export function keytypeEdit(id, keytype, cateIds, state) {
    return request({
        url: '/v1/KeyType/KeyTypeEdit',
        method: 'post',
        data: {
            id: id,
            keytype: keytype,
            cateIds: cateIds,
            state: state
        }
    })
}

export function keytypeDel(id) {
    return request({
        url: '/v1/KeyType/KeyTypeDel',
        method: 'post',
        data: {
            id: id,
        }
    })
}
